<template>
  <div class="px-4 bg-white rounded p-4 border">
    <FacebookCampaign
      v-if="this.channel.channableType === 'facebook_campaign'"
      :facebook-campaign="this.channel.channableData"
    >
      <VDropdown
        v-if="$membershipHasPermissionTo('edit channels,delete channels')"
        right
        class="ml-4"
      >
        <template #button="dropdownProps">
          <button class="btn btn-ghost text-sm px-3" @click="dropdownProps.open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </button>
        </template>

        <template #default="dropdownProps">
          <VDropdownMenu>
            <a
              v-if="$membershipHasPermissionTo('delete channels')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('channel-delete', channel))"
              >Delete</a
            >
          </VDropdownMenu>
        </template>
      </VDropdown>
    </FacebookCampaign>
    <GoogleAdsCampaign
      v-if="this.channel.channableType === 'ga_campaign'"
      :ga-campaign="this.channel.channableData"
    >
      <VDropdown
        v-if="$membershipHasPermissionTo('edit channels,delete channels')"
        right
        class="ml-4"
      >
        <template #button="dropdownProps">
          <button class="btn btn-ghost text-sm px-3" @click="dropdownProps.open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </button>
        </template>

        <template #default="dropdownProps">
          <VDropdownMenu>
            <a
              v-if="$membershipHasPermissionTo('delete channels')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('channel-delete', channel))"
              >Delete</a
            >
          </VDropdownMenu>
        </template>
      </VDropdown>
    </GoogleAdsCampaign>
  </div>
</template>

<script>
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';
import FacebookCampaign from './channelLine/FacebookCampaign.vue';
import GoogleAdsCampaign from './channelLine/GoogleAdsCampaign.vue';

export default {
  components: {
    FacebookCampaign,
    GoogleAdsCampaign,
    VDropdown,
    VDropdownMenu,
  },
  props: {
    channel: { type: Object, required: true },
  },
};
</script>
